import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import './index.tailwind.css';
import AppShell from './AppShell';
import ScrollToTop from './ScrollToTop';
import { store } from './services/store';

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ScrollToTop>
        <AppShell />
      </ScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx